// Browser helpers for saving and opening files.

/** Save bytes or text as a file through a temporary <a download> link. */
export function downloadBytes(bytes: Uint8Array | string, filename: string, mime: string): void {
  let part: BlobPart;
  if (typeof bytes === 'string') part = bytes;
  else {
    const copy = new Uint8Array(bytes.byteLength);
    copy.set(bytes);
    part = copy;
  }
  const blob = new Blob([part], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Give the browser time to start the download before revoking.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

/** Let the user choose a file. Resolves null when the dialog is cancelled. */
export function pickFile(accept: string): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.style.display = 'none';
    let done = false;
    const finish = (f: File | null) => {
      if (done) return;
      done = true;
      window.removeEventListener('focus', onFocus);
      input.remove();
      resolve(f);
    };
    // Fallback for browsers without the 'cancel' event: the window regains focus after the dialog closes.
    const onFocus = () => setTimeout(() => finish(input.files?.[0] ?? null), 1000);
    input.addEventListener('change', () => finish(input.files?.[0] ?? null));
    input.addEventListener('cancel', () => finish(null));
    document.body.appendChild(input);
    window.addEventListener('focus', onFocus, { once: true });
    input.click();
  });
}
